import _Hidden from '@material-ui/core/Hidden'
export const Hidden = _Hidden as any
